import { aboutService } from '~/services/about';
import { About } from '~/models/about';

export const useAboutState = () => ({
	aboutState: useState<About.Model | null>('aboutState', () => null),
	aboutLoaded: useState<boolean>('aboutLoaded', () => false),
	aboutPending: useState<boolean>('aboutPending', () => true),
});

export const useAbout = () => {
	const { aboutState, aboutLoaded, aboutPending } = useAboutState();

	/**
	 * Fetch about
	 */
	const fetchAbout = async () => {
		if (aboutLoaded.value) return;

		aboutPending.value = true;

		try {
			const response = await aboutService.fetch();
			aboutState.value = response;
			aboutLoaded.value = true;
		} catch (err) {
			console.error('Failed to fetch About:', err);
		} finally {
			aboutPending.value = false;
		}
	};

	/**
	 * Refresh about
	 */
	const refreshAbout = async () => {
		aboutLoaded.value = false;

		await fetchAbout();
	};

	return {
		aboutState,
		aboutPending,

		fetchAbout,
		refreshAbout,
	};
};
